import React from "react";
import { CTAButton } from "./CTAButton";
import { images } from "../data/landing";
export function FinalCTA() {
  return <section className="bg-navy-900 px-5 py-16 text-white sm:py-20" data-id="element-120" data-mp="3udp0mtecbqr2">
      <div className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="c7ag2blkgijp">
        <h2 className="font-display text-3xl font-black leading-tight sm:text-4xl" data-id="element-122" data-mp="c4o665b7dqyb">
          Ready to Organize Your Complete Denture Reference Library?
        </h2>
        <p className="mt-3 text-xl font-bold text-gold-300" data-id="element-123" data-mp="m3x04y62j5ko">Six Volumes. Five Bonuses. One Practical Reference System.</p>
        <img src={images.product} alt="Denture Blueprint collection" className="mx-auto mt-6 w-full max-w-md" loading="lazy" data-id="element-124" data-mp="h5lochw7qkzt" />
        <p className="mt-6 text-base leading-relaxed text-navy-200" data-id="element-125" data-mp="qvoqb7lbb9aa">
          Bring your complete denture assessment materials together in one organized digital collection — visual references, assessment checklists, comparison tables, and documentation templates available whenever you need to review a topic.
        </p>
        <p className="mt-4 text-lg font-bold" data-id="element-126" data-mp="2c56cy8srgdli">Get instant access today for $27.</p>
        <div className="mt-7" data-id="element-127" data-mp="2h3rcs743ov9f">
          <CTAButton label="Yes! I Want Denture Blueprint" sub="One-Time Payment · Instant Digital Access · Lifetime Access · 7-Day Guarantee" data-id="element-128" data-mp="2h4srclkbrzvw" />
        </div>
      </div>
    </section>;
}